module.exports = __webpack_public_path__ + "static/media/EconomyPumpShopView.20df02b6.jpg";